import { Box, styled } from '@mui/material';
import { useHoldingClassInvestmentData } from './useHoldingClassInvestmentData';
import InvestmentTable from './InvestmentTable';
import { HoldingClassInvestmentsConsiderationValues } from '../../../types';
import { CurrencyCode } from 'further-types/lp/vehicle';
const TableContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
});

type Props = {
  holdingClassInvestmentsConsiderationValues: Array<HoldingClassInvestmentsConsiderationValues>;
  currency: CurrencyCode;
};

const HoldingClassSplitPerInvestmentTable: React.FC<Props> = ({
  holdingClassInvestmentsConsiderationValues,
  currency,
}) => {
  const { allHoldingClasses, groupedByInvestment } =
    useHoldingClassInvestmentData(holdingClassInvestmentsConsiderationValues);

  return (
    <TableContainer>
      {Object.entries(groupedByInvestment).map(
        ([investmentId, investmentHoldingClasses], index, array) => (
          <InvestmentTable
            key={investmentId}
            investmentId={investmentId}
            investmentHoldingClasses={investmentHoldingClasses}
            allHoldingClasses={allHoldingClasses}
            showHeader={index === 0}
            currency={currency}
            isFirst={index === 0}
            isLast={index === array.length - 1}
          />
        ),
      )}
    </TableContainer>
  );
};

export default HoldingClassSplitPerInvestmentTable;
